export function scrollToValidationError(error: string) {
    const warning = document.getElementsByClassName('has-danger');
    if (warning.length > 0) {
        warning[0].scrollIntoView({ block: 'center', inline: 'start' });
    } else {
        throw new Error(`Unable to jump to Error. Error keys: ${error}.`);
    }
}
